import { createApp } from 'vue'
import Variance from './Variance.vue'
import './assets/global.css'

createApp(Variance).mount('#variance')
